<template>
  <FormViewBase title="Customer Signup">
    <template #header>
      <CustomerFindAccountByPhoneNotice />
    </template>
    <template #default>
      <v-card-text class="customer-login-form">
        <transition name="fade" mode="out-in">
          <SignupEmailPassForm />
        </transition>
      </v-card-text>
    </template>
    <template #actions>
      <v-card-actions>
        <v-row class="text-center text-h6">
          <v-col class=""
            >Signed up already?
            <router-link exact to="/login" class="ml-1"
              >Login to Your Account</router-link
            >
          </v-col>
        </v-row>
      </v-card-actions>
    </template>
  </FormViewBase>
</template>

<script>
import FormViewBase from '@/views/FormViewBase'
import { CustomerRoutes } from '@/constants/RouteNames'
import SignupEmailPassForm from '@/components/SignupEmailPassForm'
import CustomerFindAccountByPhoneNotice from '@/components/CustomerFindAccountByPhoneNotice'
export default {
  name: 'CustomerSignupView',
  components: {
    FormViewBase,
    SignupEmailPassForm,
    CustomerFindAccountByPhoneNotice,
  },
  data: () => {
    return {
      shouldUseEmailForLogin: true,
      emailHint: '',
      PhoneLoginRoute: CustomerRoutes.LOGIN_WITH_PHONE,
    }
  },
  methods: {
    validatedPhoneHandler(email) {
      this.$router.push(`/login/email/${email}`)
    }, // validatedPhoneHandler
  },
}
</script>
